<template>
    <st-filters-pagination
        stateModule="decisionPurpose/list"
        :filters="filters"
        :total="total"
        @change="doFilter"
        :header="$t('DECISION_PURPOSE.LIST.TITLE')"
        :moreFilters="false"
        :showErase="false"
    >
        <template #filters-toolbar>
            <slot name="toolbar"></slot>
        </template>
        <slot></slot>
    </st-filters-pagination>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FilterSchema } from '@/shared/form/filter-schema';
    import { DecisionPurposeModel } from '@/modules/decision-purpose/decision-purpose-model';

    const { fields } = DecisionPurposeModel;

    const filterSchema = new FilterSchema([
        fields.name,
    ]);

    export default {
        name: 'DecisionPurposeListFilter',
        data() {
            return {
                filters: filterSchema.fields,
                currentPage: 1,
            };
        },
        computed: {
            ...mapGetters({
               total: 'decisionPurpose/list/total',
            }),
        },
        methods: {
            ...mapActions({
                doFetch: 'decisionPurpose/list/doFetch',
            }),
            refresh() {
                this.doFilter(this.params);
            },
            async doFilter(params) {
                this.params = params;
                this.doFetch(params);
            },
        },

    };
</script>

<style scoped>

</style>
